import { Component, OnInit, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableHeaderParams } from '../../../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { ITableDataParams } from '../../../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { ITableConfig } from '../../../../../../../../projects/common/src/app/interfaces/table/table-config';
import { TableConfigService } from '../../../../../../../../projects/common/src/app/services/table/table-config.service';
import { Subscription } from 'rxjs';
import { TotalExtractionService } from '../../../../services/total-extraction/total-extraction.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ITableLargeColumnConfig } from 'projects/common/src/app/interfaces/table/table-large-column-config';

@Component({
  selector: 'app-first-last-loop-detail-table',
  templateUrl: './first-last-loop-detail-table.component.html',
  styleUrls: ['./first-last-loop-detail-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FirstLastLoopDetailTableComponent implements OnInit, OnDestroy {
  @Input() public loopDetailModalTitle: string;
  @Input() public loopDetailModalSubtitle: string;
  @Input() public shiftCharDetail: string;
  @Input() public inputDate: string;
  @Input() public shiftId: string;
  public tableConfig: ITableConfig;
  private loopDetailSubscription: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    private tableConfigService: TableConfigService,
    public totalExtractionSvc: TotalExtractionService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  /**
   * On init component
   */
  public ngOnInit(): void {
    this.getData();
  }

  /**
   * Function to get loops data
   */
  public getData(): void {
    let customEvent = {};
    if (this.loopDetailModalTitle === 'first-loop-modal-title') {
      this.loopDetailSubscription = this.totalExtractionSvc
        .getFirstLoopDetailByShiftCompany(this.inputDate, parseFloat(this.shiftId), 'ShiftStart')
        .subscribe(
          (resp) => {
            this.setTableConfig(resp);
          },
          (error) => console.log,
        );
      customEvent = {
        modal_widget: 'first-loop-modal',
      };
    } else {
      this.loopDetailSubscription = this.totalExtractionSvc
        .getLastLoopDetailByShiftCompany(this.inputDate, parseFloat(this.shiftId), 'ShiftEnd')
        .subscribe(
          (resp) => {
            this.setTableConfig(resp);
          },
          (error) => console.log(error),
        );
      customEvent = {
        modal_widget: 'last-loop-modal',
      };
    }
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
  }

  /**
   * Function to set table configuration
   */
  private setTableConfig(tableData: any[]): void {
    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'machine_name', isLargeColumn: true, flexGrow: 0.8 },
      { field: 'operator', isLargeColumn: true, flexGrow: 1.3 },
      { field: 'extraction', isLargeColumn: true, flexGrow: 0.8 },
      { field: 'dump', isLargeColumn: true, flexGrow: 0.8 },
      { field: 'finishTime', isLargeColumn: true, flexGrow: 1.3 },
    ];
    const headerParams: ITableHeaderParams = {
      data: tableData,
      customLargeColumns,
    };

    const datasetParams: ITableDataParams = {
      tableData,
      dateConfig: [{ field: 'finishTime', format: 'date-time' }],
      customLargeColumns,
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset };
  }

  /**
   * On destroy component
   */
  public ngOnDestroy(): void {
    if (this.loopDetailSubscription) {
      this.loopDetailSubscription.unsubscribe();
    }
  }
}
